<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Leads List</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select class="select-default" v-model="pagination.per_page" placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            :data="tableData"
            border
            style="width: 100%;"
            height="600"
          >
            <el-table-column
              v-for="(column, index) in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :sortable="column.sortable || false"
              :align="column.align"
              :header-align="column.align"
              v-if="!column.hidden"
              :formatter="column.formatter || null"
              :fixed="column.fixed || false"
            ></el-table-column>

            <el-table-column :min-width="200" fixed="right" class-name="td-actions" label="Actions">
              <template slot-scope="props">
                <p-button type="info" size="sm" icon @click="handleLike(props.$index, props.row)">
                  <i class="fa fa-eye"></i>
                </p-button>
                <p-button
                  type="success"
                  size="sm"
                  icon
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="warning"
                  size="sm"
                  icon
                  @click="handleConvert(props.$index, props.row)"
                >
                  <i class="fas fa-sync"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
                
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p
            class="category"
          >Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.current_page"
            :per-page="Number.parseInt(pagination.per_page)"
            :total="pagination.total"
            @input="changePage()"
          ></p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
// import users from "../Tables/users.js";
import swal from 'sweetalert2'
import { mapGetters } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  components: {
    PPagination
  },
  mounted() {
    this.$store.dispatch("fetchLeads", { perPage: 10, page: 1 });
  },
  watch: {
      searchQuery: function (val) {
          this.$store.dispatch("fetchLeads", {
              searchQuery: this.searchQuery,
              per_page: this.pagination.per_page,
              page: this.pagination.current_page
          }); 
      }
  },
  computed: {
    ...mapGetters({
      tableData: "getLeads",
      pagination: "getPagination"
    }),
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      // if (!this.searchQuery) {
      //   this.pagination.total = this.employees.length;
      //   return this.pagedData;
      // }
      // let result = this.employees.filter(row => {
      //   let isIncluded = false;
      //   for (let key of this.propsToSearch) {
      //     let rowValue = row[key].toString();
      //     if (rowValue.includes && rowValue.includes(this.searchQuery)) {
      //       isIncluded = true;
      //     }
      //   }
      //   return isIncluded;
      // });
      // this.pagination.total = result.length;
      // return result.slice(this.from, this.to);
    }
  },
  data() {
    return {
      perPageOptions: ["10", "30", "50", "100", "250", "500"],
      searchQuery: "",
      propsToSearch: ["employee_id", "name", "email", "phone"],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 150,
          hidden: true
        },
        {
          prop: "patient_id",
          label: "PAT ID",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 250
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250
        },
        {
          prop: "phone",
          label: "Phone",
          minWidth: 200
        },
        {
          prop: "billing_address_line",
          label: "B. Address",
          minWidth: 250
        },
        {
          prop: "billing_state",
          label: "B. State",
          minWidth: 150
        },
        {
          prop: "billing_country",
          label: "B. Country",
          minWidth: 150
        },
        {
          prop: "billing_pin",
          label: "B. Pincode",
          minWidth: 150
        },
        {
          prop: "shipping_address_line",
          label: "S. Address",
          minWidth: 250
        },
        {
          prop: "shipping_state",
          label: "S. State",
          minWidth: 150
        },
        {
          prop: "shipping_country",
          label: "S. Country",
          minWidth: 150
        },
        {
          prop: "shipping_pin",
          label: "S. Pincode",
          minWidth: 150
        }
      ]
      // tableData: this.employees
    };
  },
  methods: {
    changePerPage() {
      this.$store.dispatch("fetchEmployees", {
        per_page: this.pagination.per_page,
        page: 1, searchQuery : this.searchQuery
      });
    },
    changePage() {
      this.$store.dispatch("fetchEmployees", {
        per_page: this.pagination.per_page,
        page: this.pagination.current_page, searchQuery : this.searchQuery
      });
    },
    handleLike(index, row) {
      // alert(`Your want to like ${row.name}`);
      this.$router.push(`/patients/view/${row.id}`);
    },
    handleEdit(index, row) {
      this.$router.push(`/patients/edit/${row.id}`);
    },
    handleDelete(index, row) {
      // this.$store.dispatch("deleteLead", row.id);
      swal({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-default btn-fill",
          confirmButtonText: "Delete it!",
          buttonsStyling: false
      })
      .then(result => { this.$store.dispatch("deleteLead", row.id); })
      .catch(cancel => { console.log(cancel) });
    },
    handleConvert(index, row) {
      this.$store.dispatch("convertLead", row.id);
    }
  }
};
</script>

<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}

.el-table,
.el-table tr,
.el-table thead th {
  background-color: white !important;
}
</style>
